"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bulkActionDialogApi = void 0;
const abortable_fetch_1 = require("../../../utils/abortable-fetch");
async function bulkActionDialogApi(url, filters, ids, params) {
    var _a;
    try {
        if (ids.length > 0) {
            await abortable_fetch_1.abortableFetch(url, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                }),
                body: JSON.stringify({
                    ids,
                    ...params,
                }),
            }).json();
        }
        else {
            await abortable_fetch_1.abortableFetch(url, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                }),
                body: JSON.stringify({
                    filters,
                    ...params,
                }),
            }).json();
        }
        return {
            status: true,
        };
    }
    catch (err) {
        console.log('Bulk action error: ', err);
        return {
            status: false,
            error: (_a = err.message) !== null && _a !== void 0 ? _a : err,
        };
    }
}
exports.bulkActionDialogApi = bulkActionDialogApi;
//# sourceMappingURL=bulk-action-dialog-api.js.map